import { render, staticRenderFns } from "./ImportGroupPermissions.vue?vue&type=template&id=62c0d0de&scoped=true&"
import script from "./ImportGroupPermissions.vue?vue&type=script&lang=ts&"
export * from "./ImportGroupPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0d0de",
  null
  
)

export default component.exports